export const REDUCER_NAME="invoiceSlice";

export interface iInvoiceListResponse {
    id: string;
    username: string;
    name: string;
    avatar: string;
    email: string;
    status: string;
    createdAt: string;
    dueDate: string;
    amount: string;
}

export interface iInvoiceWithItems {
    fromName?: string;
    fromAddress?: string;
    fromPhone?: string;
    toName?: string;
    toAddress?: string;
    toPhone?: string;    
    invoiceNumber?: string;
    createDate?: Date; 
    dueDate?: string;
    status?: string;
    shipping?: number;
    discount?: number;
    taxes?: number;
    items?: Array<{
        item?: string;
        description?: string;
        quantity?: number;
        price?: number;
    }>;
}

export interface iInvoiceState {
    invoice: iInvoiceWithItems | null;
    isLoading: boolean;
    errorMessage: string | null;
}
